import type { BoxProps, ImageProps } from "@chakra-ui/react";

const imageStyles: ImageProps = {
  w: "full",
  borderRadius: "xl",
  objectFit: { md: "scale-down", lg: "cover" },
};

const boxStyles: BoxProps = {
  pos: "absolute",
  maxWidth: "372px",
  bottom: { base: "90%", lg: "20%" },
};

export { imageStyles, boxStyles };
